module.exports = __webpack_public_path__ + "static/mindstorms-6ebab0b6e298148f5ab964dd2dc867f2.jpg";